import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_task.scss';
import Snackbars from '../Reusables/Snackbar';

import downArrow from '../../images/common/bluedownarrow.png';
import upArrow from '../../images/common/blueuparrow.png';
import closeIcon from '../../images/popups/upload/closeicon.png';

function ClickOutside(ref, setDropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function AddTask(props) {
    const {show, handleClose, getDetails, taskCount, taskerror, setTaskError, taskDetailsshow, setTaskDetailsshow} = props
    const [isDropdownClicked, setDropdownClick] = useState(false);
    const [orderList, setOrderList] = useState([]);
    const [open, setOpen] = useState(false);

    const dropdownwrapperRef = useRef(null);
    ClickOutside(dropdownwrapperRef, setDropdownClick);

    useEffect(() => {
        var orderArray = [];
        for(var i = 1; i <= taskCount+1; i++) {
            orderArray.push(i);
        }
        setOrderList(orderArray);
        setTaskDetailsshow({
            ...taskDetailsshow,
            idTaskTemplateTaskRelation: 0,
            taskName: null,
            order: orderArray.length
        })
    }, [taskCount, show])

    const handleName = (taskName) => {
        setTaskDetailsshow({
            ...taskDetailsshow,
            taskName: taskName
        })
    }

    const handleOrder = (taskOrder) => {
        setDropdownClick(!isDropdownClicked);
        setTaskDetailsshow({
            ...taskDetailsshow,
            order: taskOrder
        })
    }

    const handleDropdown = () => {
        setDropdownClick(!isDropdownClicked);
    }

    const handleAddTask = () => {
        if((taskDetailsshow.taskName === '' || taskDetailsshow.taskName === null) && (taskDetailsshow.order === '' || taskDetailsshow.order === null || taskDetailsshow.order === "Select Order")) {
            setOpen(true)
            setTaskError('Task Name and Order is mandatory');
        }
        else if(taskDetailsshow.order === '' || taskDetailsshow.order === null || taskDetailsshow.order === "Select Order") {
            setOpen(true)
            setTaskError('Order is mandatory');
        }
        else if(taskDetailsshow.taskName === '' || taskDetailsshow.taskName === null) {
            setOpen(true)
            setTaskError('Task Name is mandatory');
        }
        else {
            handleClose();
            getDetails(taskDetailsshow);
        }
    }

    return (
        <>
            {console.log("Task Order", orderList)}
            <Modal
                show={show}
                onHide={handleClose} className='add-task-popup'
                centered>
                <Modal.Body className='add-task-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='add-task-popup-header'>Add Task</div>
                    {/* <div className='error-message'>{taskerror}</div> */}
                    <div className='add-task-popup-body'>
                        <div className='name-container'>
                            <div className='label required'>Name</div>
                            <div><input type="text" onChange={(e) => handleName(e.target.value)} maxLength={255}/></div>
                        </div>
                        <div className='order-container'>
                            <div className='label required'>Order</div>
                            <div className='dropdown dropdown-order-container' ref={dropdownwrapperRef}>
                                <div className='dropdown-name-img dropdown-order' onClick={handleDropdown}>
                                    <div className='dropdown-name'>{taskDetailsshow.order}</div>
                                    <div><img className='arrow' src={isDropdownClicked ? upArrow : downArrow} alt=""></img></div>
                                </div>
                                {isDropdownClicked &&
                                    <div className='dropdown-list'>
                                        {
                                            orderList.length > 0 && orderList.map((item, index) => {
                                                return (
                                                    <div className='dropdown-content-inner order-dropdown-inner' key={index} 
                                                    onClick={() => handleOrder(item)}>{item}</div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button onClick={handleAddTask}>Add</button>
                    </div>            
                </Modal.Body>
            </Modal>

            <Snackbars error={taskerror} open={open} setOpen={setOpen}/>
        </>
    );
}

export default AddTask;